import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QrStudio } from "../qrcode/qr-studio.js";
import "../client/styles.css";

const root = document.getElementById("root");
if (root === null) throw new TypeError("QR Studio root is missing");
createRoot(root).render(
    <StrictMode>
        <QrStudio />
    </StrictMode>
);
